import { render } from "./GameItem.vue?vue&type=template&id=75596046"
import script from "./GameItem.vue?vue&type=script&lang=js"
export * from "./GameItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/timobile/gitlab_gamotions/gamotions-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__